<div class="login-main-wrapper" #consentArea>
  <div class="inner-wrapper d-flex flex-column flex-lg-row overflow-hidden">
    <div class="">
      <app-left-layout></app-left-layout>
    </div>
    <div
      class="psoition-relative register-right-side flex-fill d-flex flex-column justify-content-center align-items-center vh-100 overflow-lg-auto">
      <div class="right-content p-3 p-lg-0">
        <!-- <app-google-translate></app-google-translate> -->
        @if (selectedStep === step.REGISTER) {
          <div class="mb-4">
            <h2 class="fs-32 fw-700 m-0 mb-2">
              Create Your Account
            </h2>
            <p class="fs-16 fw-400 text-secondary m-0">
              Please fill in your details to get started.
            </p>
          </div>
        }

        @if (selectedStep == step.REGISTER) {
          <div class="">
            <app-google-sign-in [country_id]="counCurData.country_id"
            [currency_id]="counCurData.currency_id"></app-google-sign-in>
            <div class="row m-0">
              <div class="col text-secondary p-0">
                <hr class="w-100">
              </div>
              <div class="col-1 p-0"><span class="w-100 text-center ms-2">or</span></div>
              <div class="col text-secondary p-0">
                <hr class="w-100">
              </div>
            </div>
          </div>
        }

        @if (selectedStep == step.REGISTER) {
          <div class="">
            <form class="h-100" (submit)="submitForm()">
              <div class=" pb-0 h-100 flex-wrap register-business-div">
                <ng-container [formGroup]="signUpForm">
                  <div class=""
                    [ngClass]="[(signUpForm && signUpForm['controls'] && signUpForm['controls']['doctor_name']) && signUpForm['controls']['doctor_name'].touched && signUpForm['controls']['doctor_name'].invalid  ? ' inputContainer custom-form ' : 'custom-form']">
                    <label for="text" class="label-name w-100 fs-14"><span
                      class="content-name f-c-p-3 fw-700 fs-14">
                    Full Name </span>
                  </label>
                  <input type="text" class="input_field w-100" name="doctor_name" autocomplete="off"
                    required name="doctor_name" trim="true" maxlength="30"
                    formControlName="doctor_name" placeholder="Enter Your Name" (blur)="trimData()" />
                  </div>
                  @if ((signUpForm && signUpForm['controls'] && signUpForm['controls']['doctor_name']) && (signUpForm['controls']['doctor_name'].touched  && signUpForm['controls']['doctor_name'].invalid && !signUpForm['controls']['doctor_name'].dirty)) {
                    <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                      >
                      Please enter name.
                    </p>
                  }
                  @if ((signUpForm && signUpForm['controls'] && signUpForm['controls']['doctor_name']) && (signUpForm['controls']['doctor_name'].touched  && signUpForm['controls']['doctor_name'].invalid  && signUpForm['controls']['doctor_name'].dirty)) {
                    <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                      >
                      Please enter valid name.
                    </p>
                  }
                  <div class=" form-group pr-md-0 mt-2">
                    <div class=""
                      [ngClass]="[ signUpForm && (signUpForm['controls']['doctor_email'].touched && signUpForm['controls']['doctor_email'].invalid || (signUpForm['controls']['doctor_email'] && signUpForm['controls']['doctor_email']['errors'])) ? 'custom-form inputContainer' : 'custom-form ']">
                      <label for="text" class="label-name fs-14 fw-700 w-100">
                        Email
                      </label>
                      <input type="text" class="input_field w-100" required name="doctor_email"
                        maxlength="50" trim="true" formControlName="doctor_email" autocomplete="off"
                        placeholder="Enter Your Email" (blur)="trimData()"/>
                      </div>
                      @if ( ((signUpForm['controls']['doctor_email'].touched ) && signUpForm['controls']['doctor_email'].invalid)) {
                        <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                          >
                          Please enter valid email address.
                        </p>
                      }
                    </div>
                    <div class="col-12 mb-2 mt-2">
                      <span>
                        <label for="" class="fs-14 fw-700">Phone Number</label>
                        <span class="d-flex input_field align-items-center overflow-hidden p-0">
                          <!-- <span class="hw-40 h-100 fs-14 fw-600 d-flex align-items-center justify-content-center cursor">
                          {{ country_data.mobile_code}}
                        </span> -->
                        <input type="text" [mask]="mask" class="input_field flex-fill border-0 m-0 border-start rounded-0"
                          placeholder="Enter Phone Number" formControlName="doctor_mobile">
                        </span>
                      </span>
                      @if (signUpForm.controls['doctor_mobile'].touched && signUpForm.controls['doctor_mobile'].invalid) {
                        <p class="mat-error text-danger w-100 d-block mb-0 fs-12"
                          >
                          Please enter valid phone number
                        </p>
                      }
                    </div>
                    <div class=" form-group pr-md-0 mt-3">
                      <div class=" position-relative"
                        [ngClass]="[signUpForm['controls']['doctor_password'].touched && signUpForm['controls']['doctor_password'].invalid  ? '  b-10 m-h-56 custom-form inputContainer' : ' b-10 m-h-56 custom-form']">
                        <label for="text" class="label-name fs-14 fw-700 w-100">
                          Password
                          @if (showPassTooltip) {
<span style="
                                    box-shadow: 1px 1px 5px #000;
                                " class="position-absolute d-block bg-white px-3 py-3 mnw-300 info-tooltip border-tooltip radius-16"
                              >
                              <!-- <div class="alert">
                              <p class="fs-14 fw-700">Weak Password</p>
                              <div class=" d-flex justify-content-between">
                                <img src="assets/images/icons/Line1.png" alt="" class="me-2" width="52px" height="2px">
                                <img src="assets/images/icons/Line2.png" alt="" class="me-2" width="52px" height="2px">
                                <img src="assets/images/icons/Line3.png" alt="" class="me-2" width="52px" height="2px">
                              </div>
                            </div>  -->
                            <p style="padding: 0 0 0 12px !important;margin-bottom: 0px; font-size: 16px;" [ngClass]="passwordStrengthClass"
                              class="m-0 fs-12 fw-800 fs-12 m-0 p-0">
                              {{!passwordStrength || passwordStrength === 'Empty'? 'Password must contain' : passwordStrength}}
                            </p>
                            <div class="d-flex align-items-center justify-content-between my-2"
                              style="padding-left: 10px;">
                              @for (item of [].constructor(4); track item; let i = $index) {
                                <span class="w-52 mx-1"
                                  [ngClass]="((i < totalStrength) && ((totalStrength === 1)) ? 'border-orange' : (((i < totalStrength) && (totalStrength === 2))? 'border-orange' : (((i < totalStrength) && (totalStrength === 3))? 'border-green' : (((i < totalStrength) && (totalStrength === 4))? 'border-green' : 'border-top'))))">
                                </span>
                              }
                            </div>
                            <p class="fs-14 fw-700 color-22 ms-3">Password must have</p>
                            <ul class="tooltip-list" style="text-align: left;font-size: 14px;">
                              <li style="display: flex;align-items: start;"
                                [ngClass]="{'text-decoration-line-through color-167': hasMaxChar}"
                                class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                style="display: flex;justify-content: center;align-items: center;"
                                class="me-2 hw-16"
                                [ngClass]="{'p-1 bg-blue-206': hasMaxChar}"><img
                                [src]="hasMaxChar ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                              alt=""></span>Atleast 8 characters</li>
                              <li style="display: flex;align-items: start;"
                                [ngClass]="{'text-decoration-line-through color-167': hasUpperCase}"
                                class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                style="display: flex;justify-content: center;align-items: center;"
                                class="me-2 hw-16"
                                [ngClass]="{'p-1 bg-blue-206': hasUpperCase}"><img
                                [src]="hasUpperCase ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                              alt=""></span>Upper and lower case</li>
                              <li style="display: flex;align-items: start;"
                                [ngClass]="{'text-decoration-line-through color-167': hasSpecialChar}"
                                class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                style="display: flex;justify-content: center;align-items: center;"
                                class="me-2 hw-16"
                                [ngClass]="{'p-1 bg-blue-206': hasSpecialChar}"><img
                                [src]="hasSpecialChar ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                              alt=""></span>Add a symbol (Like !&#64;#$%^&*)</li>
                              <li style="display: flex;align-items: start;"
                                [ngClass]="{'text-decoration-line-through color-167': hasNumber}"
                                class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                style="display: flex;justify-content: center;align-items: center;"
                                class="me-2 hw-16"
                                [ngClass]="{'p-1 bg-blue-206': hasNumber}"><img
                                [src]="hasNumber ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                              alt=""></span>Include a number (0-9) </li>
                            </ul>
                          </span>
                        }
                      </label>
                      <div class="position-relative">
                        <input [type]="!hidePwd ? 'password' : 'text'" class="input_field_pass w-100"
                          name="password" formControlName="doctor_password" autocomplete="off"
                          required placeholder="Enter Your Password" required (focus)="showPassTooltip = true" (blur)="showPassTooltip = false" />
                          <img [src]="hidePwd ? 'assets/images/icons/open-eye.svg' : 'assets/images/icons/close-eye.svg'"
                            alt="" class="position-absolute eye-icon cursor"
                            (click)="hidePwd = !hidePwd">
                          </div>
                        </div>
                        @if (totalStrength && totalStrength !== 4) {
                          <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                            >
                            Please enter valid password.
                          </p>
                        }
                        @if (signUpForm['controls']['doctor_password']?.errors?.['cannotContainSpace']) {
                          <p class="mat-error mb-0 ml-0 pl-0 fs-14 fw-600 text-danger"
                            >
                            The password must not contain any spaces.
                          </p>
                        }
                      </div>
                      <!-- (should be greater than 6 characters). -->
                      <!-- <p class="reffer-code my-2 fs-14 fw-500 cursor blue-theme-color" *ngIf="!referral_code"
                      (click)="showReferralModal()">
                      I have partner referral code
                    </p> -->
                    @if (referral_code) {
                      <div class="d-flex align-items-center justify-content-between">
                        <p
                          class="reffer-code green my-2 fs-14 fw-500 cursor d-flex align-items-center justify-content-between">
                          <img src="assets/images/icons/reffer-icon.svg" alt="" class="me-2"> Referral
                          Code {{referral_code}} added
                        </p>
                        @if (referralCodeExist) {
                          <img src="assets/images/icons/red-delete-icon.svg" alt=""
                            class="cursor" (click)="RemoveReferralCode()">
                        }
                      </div>
                    }
                    <div class=" py-2">
                      <div class="consent-notice fs-14 fw-400 p-3 cursor" role="button" tabindex="0"
                        (click)="openLegalDocuments()" (keydown.enter)="openLegalDocuments()"
                        (keydown.space)="$event.preventDefault(); openLegalDocuments()">
                        Before you continue, please review and accept the
                        <span class="fw-700">Terms &amp; Conditions</span> and
                        <span class="fw-700">Privacy Policy</span>.
                      </div>
                        @if (signUpForm['controls']['TnC'].touched && !signUpForm['controls']['TnC'].value) {
                          <p class="mat-error mb-0 ml-0 pl-0 text-danger fs-14"
                            >
                          Please accept Terms and Privacy policy.</p>
                        }
                      </div>
                    </ng-container>
                    <div class=" form-group mt-3">
                      <button [disabled]="signUpForm.invalid" button-primary-auth type="submit"
                      class="btn btn-secondary fs-16 w-100 fw-700 mb-3">Review &amp; Continue</button>
                      <!-- (click)="socialSignIn()" -->
                      <!-- <app-google-sign-in [country_id]="counCurData.country_id"
                    [currency_id]="counCurData.currency_id"></app-google-sign-in> -->
                    @if ((signUpForm['errors'])) {
                      <p class="mat-error mb-0 ml-0 pl-0">
                        {{signUpForm && signUpForm['errors']}}
                      </p>
                    }
                  </div>
                </div>
                <p class="fs-14 fw-400 m-0 text-center">
                  Already have an account?
                  <span class="fw-700 link-text cursor blue-theme-color" [routerLink]="'/login'">Log In</span>
                </p>
              </form>
            </div>
          }

          @if (selectedStep === step.VERIFY_OTP) {
            <div class="mb-4">
              <h2 class="fs-32 fw-700 m-0 mb-3">
                Verify Phone Number
              </h2>
              <p class="fs-16 fw-400 text-secondary m-0">
                We’ve sent a 6-digit verification code to <span class="text-primary">(XXX) XXX {{last4Number}}</span>. Please enter the code below to <br> verify your phone number.
              </p>
            </div>
            <div class=" form-group mt-4 mb-3">
              <!-- <p class="fs-14 fw-500 text-secondary">Enter Verification Code</p> -->
              <form [formGroup]="otpForm" action="" (submit)="verifyOtp()">
                <div class="form-group otp_fields new-otp_fields mb-3 mt-2 d-flex justify-content-between">
                  @for (item of otpValueGroup; track item; let index = $index) {
                    <input id={{item}} (input)="onInput($event , index)"
                      (keydown.space)="$event.preventDefault()" (keydown.tab)="$event.preventDefault()"
                      (keydown.backspace)="onDelete($event , index)" formControlName="{{item}}"
                      type="text" maxlength="1"
                      placeholder="-" (paste)="onPasteHandler($safeNavigationMigration($event.clipboardData?.getData('text/plain')))"/>
                  }
                </div>
                @if (countdown > 0) {
                  <div class="py-3 fs-14 fw-500 text-secondary">Didn’t receive verification code? Resend in <b>{{ formatTime(countdown) }}</b></div>
                }
                @if (countdown <= 0) {
                  <div class="mb-4 ">Didn’t receive the code? <a class="color-blue cursor" (click)="renewOtp()">Resend Code</a></div>
                }
                <button [disabled]="otpForm.invalid" class="btn btn-secondary fs-16 w-100 fw-700" type="submit">Verify & Continue</button>
                <button (click)="backToSignUp()" class="btn btn-default w-100 fs-16 fw-700 mt-2" type="button">Back To Sign Up</button>
                <p class="fs-14 fw-400 pt-2 text-secondary">🔒 Your information is securely encrypted.</p>
              </form>
            </div>
            <!-- <a (click)="selectedStep = step.MOBILE_NUMBER" class="text-line cursor">Change mobile number</a> -->
          }

          @if (selectedStep === step.LOADING) {
            <P (click)="selectedStep = step.COMPLETE" >Loading</P>
          }

          @if (selectedStep === step.COMPLETE ) {
            <img src="assets/images/icons/success-proposal.png" alt="" class="">
            <h1>Welcome Aboard!</h1>
            <p>Your account is all set up and ready to go.</p>
          }


          @if (selectedStep === step.COMPLETE_PROFILE) {
            <div class="loader-wrapper" style="position: relative; margin: auto;">
              <svg class="donut" viewBox="0 0 120 120" width="200" height="200">
                <circle class="donut-ring" cx="60" cy="60" r="54" stroke-width="6" fill="transparent" />
                <circle class="donut-segment" cx="60" cy="60" r="54" stroke-width="6" fill="transparent"
                  [attr.stroke-dasharray]="339.292" [attr.stroke-dashoffset]="339.292 - (339.292 * idverification / 100)">
                </circle>
              </svg>
              @if (!loaderComplete) {
                <span class="loader-text">{{idverification}}%</span>
              }
              @if (loaderComplete) {
                <img src="assets/images/icons/greenTick.svg" class="loader-tick" alt="Completed" />
              }
              <p class="mt-3 fs-16 fw-500 text-center">
                @if (!loaderComplete) {
                  <span>Creating your account... please wait</span>
                }
                @if (loaderComplete) {
                  <span>
                    <span class="fs-24 fw-800"> Welcome {{ signUpForm.controls['doctor_name'].value || '' }}!</span><br>
                    Your account is all set up and ready to go.
                  </span>
                }
              </p>
            </div>
          }









          <!-- <ng-container *ngIf="selectedStep === step.VERIFY_OTP">
          <div class="mb-4">
            <h2 class="fs-36 fw-600 m-0 mb-3">
              Verify your Email
            </h2>
            <p class="fs-16 fw-400 text-secondary m-0">
              We have sent a verification code to
              <b>{{signUpForm.controls['doctor_email'].value}}</b>. Please enter the code below to
              complete your verification
            </p>
          </div>
          <div class=" form-group mt-4 mb-3">
            <p class="fs-14 fw-500 text-justify">Enter Verification Code</p>
            <form [formGroup]="otpForm" action="" (submit)="verifyOtp()">
              <div class="form-group otp_fields new-otp_fields mb-3 mt-2 d-flex justify-content-between">
                <div class="">
                  <input id={{item}} (input)="onInput($event , index)"
                    (keydown.space)="$event.preventDefault()"
                    (keydown.tab)="$event.preventDefault()"
                    (keydown.backspace)="onDelete($event , index)" [formControlName]="item"
                    type="text" maxlength="1"
                    *ngFor="let item of otpValueGroup; let index = index"
                    placeholder="-"
                    (paste)="onPasteHandler($event.clipboardData?.getData('text/plain'))"/>
                  </div>
                </div>


                <div class="mb-2 " *ngIf="countdown > 0">Didn’t receive the code? {{ formatTime(countdown)
                  }}
                seconds</div>
                <div class="mb-4 " *ngIf="countdown <= 0">Didn’t receive the code? <a class="color-blue cursor" (click)="renewOtp()">Resend Code</a></div>

                <button class="btn btn-secondary w-100 fw-600 mt-2" type="submit">Verify Email</button>
                <button (click)="selectedStep = step.REGISTER" class="btn btn-default w-100 fw-600 mt-2"
                type="submit">Change Email</button>
              </form>
            </div>
            <a (click)="selectedStep = step.REGISTER" class="text-line cursor">Change your email this is commented</a>
          </ng-container> -->
        </div>
        <div class="footer bottom-10 position-absolute"> © FinanceMutual<sup>TM</sup> {{_shared.today | date:"yyyy"}}</div>
      </div>
    </div>
  </div>